import {
  FormSlug,
  ImplementationGuideForm,
  ResponseFormat,
} from "@/components/ImplementationGuide/types";
import { FieldName } from "@/components/ImplementationGuide/types/FieldName.enum";

const keyTeamMembersForm: ImplementationGuideForm = {
  title: "Key team members",
  subtitle:
    "Understand the key team members who will support a successful implementation of Newsela.",
  slug: FormSlug.KeyTeamMembers,
  form_image: "/images/implementation-guide/Key_Team_Members.svg",
  form_index: 0,
  form_description: {
    content:
      "We will be identifying members of your team that will be helping with integration and their specific roles and responsibilities.",
    recommendation: "",
  },
  questions: [
    {
      question_index: 1,
      question_text:
        "Please review your team members and their roles in implementation.",
      sub_prompt: null,
      response_format: ResponseFormat.stakeholder_cards,
      is_response_read_only: true,
      field_name: null,
    },
    {
      question_index: 2,
      question_text:
        "How will you inform your key members of their assigned responsibilities?",
      sub_prompt: null,
      response_format: ResponseFormat.textarea,
      is_response_read_only: false,
      field_name: FieldName.Key_Team_Member_Notes,
    },
  ],
};

export default keyTeamMembersForm;
